import { render, staticRenderFns } from "./AllCustomerAccountsTable.vue?vue&type=template&id=616a2567&scoped=true&"
import script from "./AllCustomerAccountsTable.vue?vue&type=script&lang=js&"
export * from "./AllCustomerAccountsTable.vue?vue&type=script&lang=js&"
import style0 from "./AllCustomerAccountsTable.vue?vue&type=style&index=0&id=616a2567&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a2567",
  null
  
)

export default component.exports